import React from 'react';
import { Buffer } from 'buffer';
import { ChevronRight } from '../../../../SVG';
export var loadSvg = function (base64EncodedSvg) {
    var svg = Buffer.from(base64EncodedSvg, 'base64').toString();
    return (React.createElement("div", { className: "flex items-center justify-center", 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: svg } }));
};
export var ChooseWorkflowButtonContent = function (_a) {
    var Icon = _a.Icon, text = _a.text;
    return (React.createElement("div", { className: "flex items-center justify-between" },
        React.createElement("div", { className: "flex items-center" },
            loadSvg(Icon),
            React.createElement("div", { className: "leading-5.75 ml-2 text-left text-base" }, text)),
        React.createElement(ChevronRight, { height: "15", width: "15" })));
};
export default ChooseWorkflowButtonContent;
